/* eslint-env browser */
import { ready, on } from 'domassist';
import { Events as ScrollEvents } from 'ga-track-scroll';
import pageLog from './page';
import outbound from './outbound';
import { Events as VideoEvents } from '../plyr/scripts';

const TrackedEvents = {};
const plugins = [pageLog, outbound];

TrackedEvents['newsletter:subscribe'] = () => ({ label: 'registration', action: 'newsletter' });
TrackedEvents['drip:subscribe'] = e => ({ label: 'registration', action: `drip ${e.detail.type}` });
TrackedEvents[ScrollEvents.Scroll] = e => {
  if (e.detail.amount === 50) {
    return { label: 'action', action: '50% scroll' };
  }
};
TrackedEvents[VideoEvents.Start] = e => ({ label: 'action', action: e.detail.type });
TrackedEvents[VideoEvents.End] = e => ({ label: 'action', action: e.detail.type });
TrackedEvents['reaction:change'] = e => ({ label: 'action', action: `reaction ${e.detail.type}` });
TrackedEvents['slide:change'] = () => ({ label: 'action', action: 'carousel' });

function logPDAT({ detail }) {
  window.gaTrack.sendEvent('pdat', detail.label, detail.action);
}

function eventHandler(event) {
  const handler = TrackedEvents[event.type];
  let detail = null;

  if (typeof handler === 'function') {
    detail = handler(event);
  }

  if (detail) {
    logPDAT({ detail });
  }
}

ready(() => {
  if (!window.gaTrack) {
    return;
  }

  const invokePlugins = () => plugins.forEach(p => p(window.gaTrack));

  Object.keys(TrackedEvents).forEach(e => on(document.body, e, eventHandler));
  on(document.body, 'pdat:log', logPDAT);
  invokePlugins();

  on(window, 'stateChange', invokePlugins);
});
